import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/A4';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得定期定額投資金額申請/變更條款說明
export function getAgreeTermsA4() {
    return get(`${url}/getAgreeTerms`);
};

// 定期定額投資金額申請/變更條款同意
export function postAgreeA4() {
    return post(`${url}/agree`);
};

/**
 * 保戶進入定期定額投資金額申請/變更前，取得先前定期定額投資金額記錄
 * @return {Object}
 */
export function getInfoA4() {
    return get(`${url}/info`);
};

/**
 * 保戶進入申請定期定額投資金額申請/變更，取得投資設定資料
 * @return {Object}
 */
export function getMopInfoA4() {
    return get(`${url}/mopInfo`);
};

/**
 * 保戶進入定期定額投資金額申請/變更，取得投資標的公司及投資標的名稱下拉式選單
 * @return {Object}
 */
export function getFundBankInfoA4() {
    return get(`${url}/fundBankInfo`);
};

/**
 * 送出申請
 * @return {Object}
 */
export function submitA4(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
};
